import React from 'react';
import { Typography, SkeletonLoader } from '@hpstellar/core';

import './specs-list.less';

export default ({ specs, loading, limit, delimeter = ' ', variant, isCaps, children }) => {
    if (!Array.isArray(specs) || (!loading && specs.length < 1)) {
        return null;
    }
    const specList = loading ? Array.from({ length: limit || 2 }) : specs.slice(0, limit || specs.length);

    return (
        <div className="quick-view-specs-list">
            {specList.map((spec, index) => {
                return (
                    <div key={index} className={`spec-item${variant ? ` ${variant}` : ''}`}>
                        <Typography variant="boldS" className="spec-name" tag="span" isCaps={isCaps}>
                            {loading ? <SkeletonLoader /> : spec.name}
                        </Typography>
                        <span className="spec-delimeter">{delimeter}</span>
                        <Typography className="spec-value" tag="span" variant="bodyS">
                            {loading ? <SkeletonLoader /> : spec.value.join(' ')}
                        </Typography>
                    </div>
                );
            })}
            {children}
        </div>
    );
};
